const config = {
  all: {
    env: process.env.NODE_ENV || 'development',
    isDev: process.env.NODE_ENV !== 'production',
    basename: process.env.PUBLIC_PATH || '/',
    baseApi: process.env.REACT_APP_BASE_API || '',
    isBrowser: typeof window !== 'undefined',
    drawerWidth: 292,
    drawerOpen: true,
    cardHeight: 233,
    rowsPerPage: 10,
    googleReCaptchaKey: process.env.REACT_APP_CLIENT_RECAPTCHA_KEY,
    currencyDecimalScale: 2,
    idsLicitacao: [13820660, 13316086, 16187295, 24239519],
    loginEcpf: {
      id: '11807',
      name: `consignet-v3`,
      formAction: 'https://autenticador.certisign.com.br/CertisignLogin/certificado/login',
      urlRetorno: `${process.env.REACT_APP_BASE_API}/api/authentication/e-cpf/certisign`
    },
    project: {
      name: process.env.REACT_APP_PROJECT,
      brand: process.env.REACT_APP_BRAND,
      favicon: process.env.REACT_APP_FAVICON,
      logo: process.env.REACT_APP_LOGO,
      logoHeader: process.env.REACT_APP_LOGO_HEADER,
      title: process.env.REACT_APP_TITLE,
      url: process.env.REACT_APP_URL,
      holding: process.env.REACT_APP_HOLDING,
      isVan: process.env.REACT_APP_IS_VAN === 'true',
      isLicitacao: process.env.REACT_APP_IS_LICITACAO === 'true',
      hasToggleLocale: process.env.REACT_APP_HAS_TOGGLE_LOCALE === 'true'
    }
  },
  test: {
    isDev: false
  },
  development: {},
  production: {}
}

export default {
  ...config.all,
  ...config[config.all.env]
}
